// Class: openfl.printing.PrintJobOptions

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var PrintJobOptions = function(printAsBitmap) {
	if(printAsBitmap == null) {
		printAsBitmap = false;
	}
	this.printAsBitmap = printAsBitmap;
}

// Meta

PrintJobOptions.__name__ = "openfl.printing.PrintJobOptions";
PrintJobOptions.__isInterface__ = false;
PrintJobOptions.prototype = {
	
};
PrintJobOptions.prototype.__class__ = PrintJobOptions.prototype.constructor = $hxClasses["openfl.printing.PrintJobOptions"] = PrintJobOptions;

// Init



// Statics




// Export

exports.default = PrintJobOptions;